import React from 'react';
import Slider from 'react-slick';
import { Box } from '@mui/material';

export default function ProductImageSlider({ images }) {
  const sliderSettings = {
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4500,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // adaptiveHeight removed for better consistency
  };

  return (
    <Box sx={{ width: '100%', maxWidth: 750, mb: { xs: 3, md: 0 } }}>
      <Slider {...sliderSettings}>
        {images.map((img, idx) => (
          <Box key={idx} sx={{ px: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Box component="img" src={img} alt={`Ixoria Product ${idx + 1}`} sx={{ width: '100%', height: 'auto', maxHeight: 750, objectFit: 'contain', borderRadius: 2, background: '#f9f9f9', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }} />
          </Box>
        ))}
      </Slider>
    </Box>
  );
}
